/** Size of Brick Breaker's world, in studs (one stud = one cell) — shared by the rules and the drawing. */
export const COLS = 12;
export const ROWS = 16;
/** The paddle's top edge sits on this row; it is one stud deep. */
export const PADDLE_ROW = 14;
export const PADDLE_W = 3;
export const BALL_R = 0.3;

export type BrickKind = "plain" | "black" | "gold";

export const POINTS: Record<BrickKind, number> = { plain: 10, black: 25, gold: 100 };

/** Brick colors by layout letter (the Toybox palette). */
export const BRICK_COLORS: Record<string, string> = {
  R: "#d8402f",
  Y: "#f0b72f",
  B: "#2f5fd0",
  G: "#2f9a55",
  K: "#2a2724",
};

/** Golden bonus bricks: a metallic gradient, light top-left to dark bottom-right. */
export const GOLD = { light: "#ffe9a3", mid: "#e2ae2a", dark: "#a8740c" };
